import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from 'src/app/services/client.service';
import {Location} from '@angular/common';
import {CourtService} from '../../../services/court.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../services/notification.service';
import {ValidateDate} from '../../../validators/date.validator';
import {ValidatePassedDate} from '../../../validators/past-date.validator';
import BMCB_REGEX from '../../../validators/regex/bmcb.regex';
import {ClientDTO} from '../../../model/clientDTO';
import {CourtDTO} from '../../../model/courtDTO';
import {ClientInviteDialogComponent} from './invite/client-invite-dialog.component';
import {ClientRevokeDialogComponent} from './revoke/client-revoke-dialog.component';
import {UserService} from '../../../services/user.service';
import {Err} from '../../../err';

@Component({
  templateUrl: './edit-client.component.html'
})
export class EditClientComponent implements OnInit {

  form: FormGroup;
  client: ClientDTO;
  courts: CourtDTO[];
  inviteRevoke = '';

  constructor(private builder: FormBuilder,
              private service: ClientService,
              private router: Router,
              private userService: UserService,
              private courtService: CourtService,
              private dialog: MatDialog,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              private _location: Location) {
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.service.getOne(params['clientId']).subscribe(client => {
        this.client = client;
        this.form = this.getForm();
        this.inviteRevoke = client.email != null && client.email !== '' ? 'INVITED' : 'REVOKED';
        this.courtService.getAll().subscribe(courts => this.courts = courts,
          error => {
            this.notificationService.errorResponse(error);
            this._location.back();
          });
      });
    });
  }

  save(form) {
    return new Promise((resolve, reject) => {
      if (form.invalid) {
        this.notificationService.warning(Err['FORM_INVALID']);
        reject();
        return;
      }
      this.service.update(this.client.id, form.value).subscribe(() => {
        this.notificationService.success('bewind opgeslagen');
        resolve();
      }, error => {
        this.notificationService.errorResponse(error);
        reject();
      });
    });
  }

  submit() {
    this.save(this.form).then(() => this._location.back());
  }

  invite() {
    const config = {data: {clientId: this.client.id}};
    this.dialog.open(ClientInviteDialogComponent, config).componentInstance.onInvite.subscribe(() => {
      this.inviteRevoke = 'INVITED';
      this.notificationService.success('rechthebbende is uitgenodigd.');
    });
  }

  revoke() {
    const config = {data: {clientId: this.client.id}};
    this.dialog.open(ClientRevokeDialogComponent, config).componentInstance.onRevoke.subscribe(() => {
      this.inviteRevoke = 'REVOKED';
      this.notificationService.success('toegang ingetrokken');
    });
  }

  private getForm() {
    return this.builder.group({
      'firstNameInitials': [this.client.firstNameInitials, [Validators.required, Validators.maxLength(255)]],
      'firstName': [this.client.firstName, [Validators.required, Validators.maxLength(255)]],
      'insertion': [this.client.insertion, [Validators.maxLength(255)]],
      'lastName': [this.client.lastName, [Validators.required, Validators.maxLength(255)]],
      'street': [this.client.street, [Validators.required, Validators.maxLength(255)]],
      'houseNumber': [this.client.houseNumber, [Validators.required, Validators.maxLength(255)]],
      'houseNumberSuffix': [this.client.houseNumberSuffix, [Validators.maxLength(255)]],
      'zipCode': [this.client.zipCode, [Validators.required, Validators.maxLength(255)]],
      'city': [this.client.city, [Validators.required, Validators.maxLength(255)]],
      'courtId': [this.client.courtId, [Validators.required]],
      'caseNumber': [this.client.caseNumber, [Validators.required, Validators.pattern(BMCB_REGEX)]],
      'caseType': [this.client.caseType, [Validators.required]],
      'dateOfBirth': [this.client.dateOfBirth, [Validators.required, ValidateDate]],
      'startDate': [this.client.startDate, [Validators.required, ValidateDate, ValidatePassedDate]],
    });
  }

  editSecondUser() {
    this.navigateAfterSave(`bewind/${this.client.id}/tweede-bewindvoerder/bewerken`);
  }

  addSecondUser() {
    this.navigateAfterSave(`bewind/${this.client.id}/tweede-bewindvoerder/toevoegen`);
  }

  private navigateAfterSave(destination: string) {
    this.notificationService.unsavedChanged(
      this.unsavedChanged(),
      () => this.save(this.form),
      () => this.router.navigate([destination]));
  }

  private unsavedChanged(): boolean {
    const value = this.form.value;
    return !(this.client.firstNameInitials === value.firstNameInitials &&
      this.client.firstName === value.firstName &&
      this.client.insertion === value.insertion &&
      this.client.lastName === value.lastName &&
      this.client.street === value.street &&
      this.client.houseNumber === value.houseNumber &&
      this.client.houseNumberSuffix === value.houseNumberSuffix &&
      this.client.zipCode === value.zipCode &&
      this.client.city === value.city &&
      this.client.courtId === value.courtId &&
      this.client.caseNumber === value.caseNumber &&
      this.client.caseType === value.caseType &&
      this.client.startDate === value.startDate);
  }
}
